// src/AppProviders.js
import React from 'react';
import { LoaderProvider } from './contexts/LoaderContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ConfigProvider } from './contexts/ConfigContext';
import { UserProvider } from './contexts/UserContext';
import { LanguageProvider } from './contexts/LanguageContext';
import AntdLocaleWrapper from './components/common/AntdLocaleWrapper';
import './assets/css/rtl.css';

const AppProviders = ({ children, initialTheme}) => (
  <LanguageProvider>
    <LoaderProvider>
      <UserProvider>
        <ConfigProvider initialTheme={initialTheme} >
          <ThemeProvider>
            <AntdLocaleWrapper>
              {children}
            </AntdLocaleWrapper>
          </ThemeProvider>
        </ConfigProvider>
      </UserProvider>
    </LoaderProvider>
  </LanguageProvider>
);

export default AppProviders;
